import React, { useState } from "react"
import styled from "styled-components"
import { useLocation } from "@reach/router"
import QRCode from "qrcode.react"
import { CenterPiece, Footer, Main } from "../styles"
import { NextButton } from "../NextButton"
import { defaultLabels } from "../../shared/defaultLabels"
import getMediaUrl from "../../../utils/mediaUrl"
import { ShareButton } from "./ShareButton"
import { InfoButton } from "../info-button/InfoButton"
import { InfoContent } from "../info-button/InfoContent"

const QRdiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;
  h2 {
    margin: 0;
  }
  padding: 10px 20px 10px 10px;
  column-gap: 20px;
`

const ScanMain = styled(Main)`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 20px 20px 60px 20px;
  @media (max-height: 800px) {
    padding: 20px 20px 60px 20px;
    div {
      margin: 0;
    }
  }
`

const ScanCenterPiece = styled(CenterPiece)`
  display: flex;
  place-content: center;
  align-items: center;
  width: 100%;
`

const ScanInstructions = styled.div`
  padding: 20px 0;
`

const LoggedIn = styled.div`
  padding: 20px 0px;
`

export const Avatar = styled.img`
  height: 150px;
  padding: 0px 10px 10px 10px;
`

export const ScanQr = props => {
  const { roomId, roomState, gameProps, gameData } = props

  const location = useLocation()
  const [pending, setPending] = useState(false)
  const [showInfo, setShowInfo] = useState(true)

  const getClientUrl = role => {
    return `${location.origin}${location.pathname.replace(
      /\/$/,
      ""
    )}/client/?room=${encodeURI(roomId)}&role=${role}&game-id=${
      gameProps.gameId
    }`
  }

  const roomCanStart = () => {
    switch (roomState) {
      case "CROWDED":
        return true
      case "FULL":
        return true
      default:
        return false
    }
  }

  const roomIsFull = () => {
    return roomState === "FULL"
  }

  const handleStart = e => {
    e.preventDefault()
    setPending(true)
    props.handleStart()
  }

  const guests = props.roomData?.guests || []
  const numberOfGuests = new Set(guests).size
  const roles = gameData?.guest_players || []
  const numberOfRoles = roles.length
  const unscannedRoles = roles.filter(
    role => !guests.includes(role.id.toString())
  )
  const roleToBeShown = unscannedRoles[0] || null

  const game_login = gameData?.game_login || null
  const game_title = gameData?.game_title || ""
  const roleToBeShownShareTitle = `${game_title} ${roleToBeShown?.title} ${game_login?.host_title}`

  const title =
    `${game_title} ${game_login?.host_title}` ||
    defaultLabels?.GAME_LOGIN_HOST_TITLE
  const description =
    game_login?.host_description || defaultLabels?.GAME_LOGIN_HOST_DESCRIPTION
  const max_players_reached =
    game_login?.host_max_players_reached ||
    defaultLabels?.GAME_LOGIN_HOST_MAX_PLAYERS_REACHED
  const host_players_logged_in =
    game_login?.host_players_logged_in ||
    defaultLabels?.GAME_LOGIN_HOST_PLAYERS_LOGGED_IN
  const host_next_button =
    game_login?.host_next_button || defaultLabels?.GAME_LOGIN_HOST_NEXT_BUTTON
  const backgroundImageUrl = game_login?.host_background_image
    ? getMediaUrl(gameProps?.strapiUrl, game_login?.host_background_image?.url)
    : null

  if (!gameData) return <ScanCenterPiece>No game data</ScanCenterPiece> //Todo: add error message
  return (
    <ScanMain backgroundImage={backgroundImageUrl} aria-disabled="true">
      <ScanCenterPiece>
        <h1>{title}</h1>
        <ScanInstructions>
          {!roomIsFull() ? (
            <span>{description}</span>
          ) : (
            <span>{max_players_reached}</span>
          )}
        </ScanInstructions>
        {!roomIsFull() && roleToBeShown && (
          <QRdiv>
            <div>
              <div>
                <h2>{roleToBeShown?.title}</h2>
              </div>
              <div>
                {" "}
                <Avatar
                  src={getMediaUrl(
                    gameProps.strapiUrl,
                    roleToBeShown?.avatar?.url
                  )}
                  alt={roleToBeShown?.title}
                />
              </div>
            </div>
            <div>
              <a
                href={getClientUrl(roleToBeShown.id)}
                target="_blank"
                rel="noreferrer"
                id="clientQR"
                aria-label="QR code"
              >
                <div>
                  <QRCode
                    value={getClientUrl(roleToBeShown.id)}
                    renderAs="svg"
                    bgColor="white"
                    style={{ height: 130, width: 130 }}
                  />
                </div>
              </a>
              <div>
                <ShareButton
                  clientUrl={getClientUrl(roleToBeShown.id)}
                  title={roleToBeShownShareTitle}
                  label={game_login?.host_share_button_label || ""}
                  description={game_login?.host_share_button_description || ""}
                />
              </div>
            </div>
          </QRdiv>
        )}

        <LoggedIn>
          {numberOfGuests} {host_players_logged_in} (max {numberOfRoles})
        </LoggedIn>
      </ScanCenterPiece>

      {showInfo && (
        <InfoContent
          gameProps={gameProps}
          gameData={gameData}
          onClose={() => setShowInfo(!showInfo)}
          isFooter
        />
      )}

      <Footer>
        <NextButton
          disabled={!roomCanStart() || pending}
          onClick={handleStart}
          children={host_next_button}
          pending={pending}
        />
      </Footer>
      <InfoButton
        gameProps={gameProps}
        gameData={gameData}
        onClick={() => setShowInfo(!showInfo)}
      />
    </ScanMain>
  )
}
